module.exports = __webpack_public_path__ + "img/页面图片修改2-3.ea68386b.png";